import { COLORS } from "./colors";

export const themes = [
  { id: "light", name: "Світла", active: [COLORS.blue, COLORS.secondary1] },
  {
    id: "dark",
    name: "Темна",
    active: [COLORS.secondary1, COLORS["light-gray"]],
  },
  {
    id: "default",
    name: "Авто",
    active: [COLORS["bg-text-color"], COLORS.white],
  },
];

export enum ActionsEnum {
  ADD = "add",
  EDIT = "edit",
  DELETE = "delete",
  EXIT = "exit",
  CONFIRM_KANBAN_MOVING = "confirm kanban card moving"
}